
import { defineComponent, ref, onMounted, PropType, computed } from "vue";
import stc from "string-to-color";
import { useDayjs } from '@/core/hook/useDayjs';
const { dayjs } = useDayjs();
import { MdPerson, MdClose } from "@vicons/ionicons4";
import { Module, Actions, Getters } from "@/store/enums/homeEnums";
import {
  Module as ParticipationModule,
  Actions as ParticipationActions,
  Getters as ParticipationGetters,
} from "@/store/enums/participationEnums";
import {
  Module as HosterModule,
  Actions as HosterActions,
} from "@/store/enums/hosterEnums";

import {
  EventStatus as ParamEventStatus,
  ParticapantStatus as ParamParticapantStatus,
  ResponseStatus as ParamResponseStatus,
  IsResolution as ParamIsResolution,
  HasReply as ParamHasReply,
} from "@/store/enums/paramsEnums";

import groupHeaderModel from "@/core/models/share/status.interface";
import eventModel from "@/core/models/share/inviteEvent.interface";
import usrResponseStatusModel from "@/core/models/share/status.interface";
import ParticipantModal from "@/components/participant/modal/participantModal.vue";
import { useThemeVars } from 'naive-ui'
import { useRouter, useRoute } from 'vue-router';

import { useStore } from "vuex";
export default defineComponent({
  name: "taskPage",
  components: {
    MdPerson,
    ParticipantModal,
  },
  props: {
    groupHeaders: {
      type: Array as PropType<Array<groupHeaderModel>>,
      required: true,
    },
    eventData: {
      type: Array as PropType<Array<eventModel>>,
      required: true,
    },
  },
  setup(props: any, context: any) {
    const store = useStore();
    const router = useRoute();
    //console.log('taskPage',router.query);
    if (router.query.EventHeaderId != undefined && router.query.EventHeaderId != '') {
      onOpenModal(router.query.EventHeaderId.toString())
    }

    const themeVars = useThemeVars();
    const showModal = ref(false);
    const modalEventID = ref<string>("NULL");
    const statusData = computed<Array<usrResponseStatusModel>>(
      () => store.getters[Module.desc + Getters.UserResponseStatuses]
    );
    
    

    

    function blockClass(status: string, hasReply: string ) {
      let result = 
      {
        'text-gray-400 bg-white hover:bg-gray-200': true,
        'text-white bg-warningColor hover:bg-warningColorHover border-warningColor': false,
      }
      if (status == ParamEventStatus.Open && hasReply == ParamHasReply.No)
      {
        result["text-gray-400 bg-white hover:bg-gray-200"] = false;
        result["text-white bg-warningColor hover:bg-warningColorHover border-warningColor"] = true;
      }
      return result;
    }

    function localdayjs( date: string) {
      return dayjs( date);
    }

    function stringColor(str: String, alpha: Boolean) {
      var colour = stc(str);
      return colour + (alpha ? "66" : "");
    }

    async function onOpenModal(eventid: string) {
      console.log(eventid)
      await store.dispatch(
        ParticipationModule.desc +
          ParticipationActions.LoadEventSchedularCountWithMyResponse,
        eventid
      );
      await store.dispatch(
        HosterModule.desc + HosterActions.LoadInvitePerson,
        eventid
      );
      await store.dispatch(
        HosterModule.desc + HosterActions.LoadEventResponse,
        eventid ?? ""
      );
      showModal.value = true;
      modalEventID.value = eventid;
    }

    function percentage(numerator: number, denominator: number) {
      return ((numerator * 100) / denominator).toFixed(0);
    }

    onMounted(() => {});

    return {
      statusData,
      dayjs,
      showModal,
      modalEventID,
      stringColor,
      onOpenModal,
      percentage,
      blockClass,
      ParamEventStatus,
      ParamHasReply,
      ParamIsResolution,
      range: ref([dayjs( new Date()).valueOf(), dayjs( new Date()).add(1,"week").valueOf()]),
      themeVars,
    };
  },
});
